import { useCallback, useState } from "react";
import { getTransactions } from "../../../components/transactions/functions";
import { useStableSearch } from "../../hooks/useStableSearch";

const DEFAULT_FILTERS = {
  q: "",
};

export function useTransactionsSearch(user) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const runSearch = useCallback(async ({ token, filters: activeFilters, isCurrent }) => {
    setLoading(true);
    setError(null);

    const { q } = activeFilters;
    const data = await getTransactions(token, undefined, undefined, q);

    if (!isCurrent()) {
      return;
    }

    if (data?.type === "error") {
      setError(data);
      setTransactions([]);
    } else if (data?.type === "success") {
      setTransactions(Array.isArray(data.data) ? data.data : []);
    } else {
      setTransactions([]);
    }

    setLoading(false);
  }, []);

  const search = useStableSearch(user?.token, filters, runSearch);
  const refresh = useCallback(() => search(), [search]);

  return { transactions, loading, error, filters, setFilters, search, refresh };
}
